import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

export const FILTER_PARAM = 'filter'

export function encodeAdvancedFilters(filters) {
    if (!filters || filters.length === 0) return null
    try {
        return btoa(unescape(encodeURIComponent(JSON.stringify(filters))))
    } catch (e) {
        return null
    }
}

export function decodeAdvancedFilters(param) {
    if (!param) return []
    try {
        const parsed = JSON.parse(decodeURIComponent(escape(atob(param))))
        return Array.isArray(parsed) ? parsed : []
    } catch (e) {
        return []
    }
}

// The `?filter=` query param is the single source of truth for advanced
// filters -- any component can call this hook to read the current filters or
// change them, with no prop drilling. Every consumer calling useSearchParams()
// re-renders when the URL changes, regardless of which component wrote it, so
// e.g. the popover applying a filter and a chip removing one both just work.
export function useAdvancedFilters() {
    const [searchParams, setSearchParams] = useSearchParams()
    const filters = useMemo(() => decodeAdvancedFilters(searchParams.get(FILTER_PARAM)), [searchParams])

    const setFilters = useCallback((newFilters) => {
        setSearchParams((previousParams) => {
            const nextParams = new URLSearchParams(previousParams)
            const encoded = encodeAdvancedFilters(newFilters)
            if (encoded) {
                nextParams.set(FILTER_PARAM, encoded)
            } else {
                nextParams.delete(FILTER_PARAM)
            }
            return nextParams
        }, { replace: true })
    }, [setSearchParams])

    return [filters, setFilters]
}
